/**
 * Created by zzy on 2019/7/23.
 */
import AppSidebar from './AppSidebar.vue'
export default AppSidebar



// WEBPACK FOOTER //
// ./src/components/appSidebar/index.js